var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-4"},[_c('dashboard-tiles',{attrs:{"tilesData":_vm.tilesData,"contactInfo":_vm.contactInfo}}),_c('v-row',[_c('v-col',{staticClass:"lighten-4"},[(!_vm.infoLoader)?_c('customer-engagement',{attrs:{"contactInfo":_vm.contactInfo,"dnm":_vm.toggleDNMSwitch}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }